import { graphql } from "relay-runtime"

export const deConfirmDuplicatePatientsMutation = graphql`
  mutation deConfirmDuplicatePatientsMutation($input: De_confirmDuplicatePatientsInput!) {
    de_confirmDuplicatePatients(input: $input) {
      de_Patient {
        id
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
